import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {MenuOutlined} from '@ant-design/icons';

export const HeaderSection = styled('header')<{ scrolled?: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 0.25rem 0.5rem;
    transition: all 0.3s ease-in-out;
    background: ${({scrolled}) =>
            scrolled ? 'rgba(255, 255, 255, 0.85)' : 'transparent'};
    backdrop-filter: ${({scrolled}) =>
            scrolled ? 'blur(20px)' : 'none'};
    -webkit-backdrop-filter: ${({scrolled}) =>
            scrolled ? 'blur(20px)' : 'none'};
    box-shadow: ${({scrolled}) =>
            scrolled ? '0 1px 20px rgba(82, 113, 255, 0.08)' : 'none'};
    border-bottom: ${({scrolled}) =>
            scrolled ? '1px solid rgba(226, 228, 240, 0.5)' : '1px solid transparent'};

    .ant-row-space-between {
        align-items: center;
        text-align: center;
    }
`;

export const LogoContainer = styled(Link)`
    display: flex;
`;

export const NavLink = styled('div')`
    display: inline-block;
    text-align: center;
`;

export const CustomNavLink = styled('div')`
    width: 203px;
    display: inline-block;

    @media only screen and (max-width: 411px) {
        width: 150px;
    }

    @media only screen and (max-width: 320px) {
        width: 118px;
    }
`;

export const Burger = styled('div')`
    @media only screen and (max-width: 890px) {
        display: block;
    }

    display: none;

    svg {
        fill: var(--primary);
    }
`;

export const NotHidden = styled('div')`
    display: flex;
    align-items: center;

    @media only screen and (max-width: 890px) {
        display: none;
    }
`;

export const Menu = styled('h5')`
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
    font-size: 1rem;
    color: var(--text-secondary);
    transition: color 0.2s ease-in;
    margin: 0.5rem 1.5rem;

    @media only screen and (max-width: 768px) {
        margin: 1.25rem 2rem;
    }
`;

export const Label = styled('span')`
    font-weight: 500;
    color: #404041;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
    font-size: 22px;
`;

export const Span = styled('span')`
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    font-weight: 500;

    &:hover,
    &:active,
    &:focus {
        color: var(--primary);
    }
`;

export const HeaderCTA = styled('button')`
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    color: #fff;
    font-size: 0.9rem;
    font-weight: 700;
    border: none;
    border-radius: var(--radius-sm);
    padding: 10px 24px;
    cursor: pointer;
    margin-left: 1rem;
    transition: all 0.3s ease-in-out;
    white-space: nowrap;

    &:hover {
        transform: translateY(-2px);
        box-shadow: var(--shadow-md);
    }

    @media only screen and (max-width: 890px) {
        margin-left: 0;
        margin-top: 1rem;
        width: 100%;
        padding: 14px 24px;
    }
`;
